import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
    MdsTextareaComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { ReportBugResultViewModel } from '@models/error-details';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

@Component({
    selector: 'medpace-report-bug-dialog',
    imports: [
        ReactiveFormsModule,
        MdsDialogComponent,
        MdsDialogContentComponent,
        MdsTextareaComponent,
        MdsButtonComponent,
        MdsDialogActionsComponent,
    ],
    standalone: true,
    templateUrl: './report-bug-dialog.component.html',
    styleUrl: './report-bug-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBugDialogComponent {
    router = inject(Router);
    dialogRef = inject(MatDialogRef<ReportBugDialogComponent, ReportBugResultViewModel>);
    reportBugFromGroup = new FormGroup({
        bugDetails: new FormControl<string>('', [notWhitespaceValidator(), maxLengthValidator(500)]),
    });

    closeDialog(): void {
        this.dialogRef.close({ save: false });
    }

    saveDialog(): void {
        if (this.reportBugFromGroup.valid) {
            const url = window.location.origin + this.router.url;
            this.dialogRef.close({
                save: true,
                description: this.reportBugFromGroup.controls.bugDetails.value,
                url: url,
            });
        } else this.reportBugFromGroup.markAllAsTouched();
    }
}
